exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".login__icon[data-v-6fbfe7a8]{position:absolute;right:6px}", "", {"version":3,"sources":["/home/webuser/akula/releases/150/spa/src/pages/auth/login/Login.scss"],"names":[],"mappings":"AACE,8BACE,kBACA,SAAA,CAAA","file":"Login.scss?vue&type=style&index=0&id=6fbfe7a8&prod&lang=scss&scoped=true&external","sourcesContent":[".login {\n  &__icon {\n    position: absolute;\n    right: 6px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
